import { Divider, Grid, Typography } from "@mui/material";

type TComponentContainer = {
  title: string;
  children: React.ReactNode;
};

function ComponentContainer({ title, children }: TComponentContainer) {
  return (
    <Grid container direction="row" spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Typography variant="h5" textTransform="capitalize">
          {title}
        </Typography>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Divider sx={{ bgcolor: "#fe5d8d" }} />
      </Grid>

      <Grid size={{ xs: 12 }} gap={4} marginTop={2}>
        {children}
      </Grid>
    </Grid>
  );
}

export default ComponentContainer;
